/**
 * Utilitários de cascata Estado→Cidade via API pública do IBGE.
 * Compartilhado entre o fluxo multi-step (ofertaFormularioMultiStepHandlers.js)
 * e o fluxo de 1 step de form-no-cep + Ofertas (ofertaFormularioNoCepOfertaHandlers.js).
 */

const IBGE_API_BASE = 'https://servicodados.ibge.gov.br/api/v1/localidades';

export function setSelectPlaceholder(selectEl, label) {
    if (!selectEl) return;
    selectEl.innerHTML = `<option value="">${label}</option>`;
}

export function appendSelectOptions(selectEl, options) {
    if (!selectEl) return;
    const html = options
        .map(option => `<option value="${option.value}">${option.label}</option>`)
        .join('');
    selectEl.insertAdjacentHTML('beforeend', html);
}

export async function loadStates(stateInput, { logPrefix = '[IBGE]' } = {}) {
    if (!stateInput) return;

    try {
        stateInput.disabled = true;
        setSelectPlaceholder(stateInput, 'Carregando estados...');

        const response = await fetch(`${IBGE_API_BASE}/estados`);
        if (!response.ok) {
            throw new Error('Falha ao buscar estados no IBGE');
        }

        const states = await response.json();
        const sortedStates = Array.isArray(states)
            ? states.sort((a, b) => (a.sigla || '').localeCompare(b.sigla || ''))
            : [];

        setSelectPlaceholder(stateInput, 'Estado*');
        appendSelectOptions(
            stateInput,
            sortedStates.map((uf) => ({ value: uf.sigla, label: uf.sigla }))
        );

        stateInput.disabled = false;
    } catch (error) {
        setSelectPlaceholder(stateInput, 'Estado*');
        stateInput.disabled = false;
        console.error(`${logPrefix} Erro ao carregar estados:`, error);
    }
}

export async function loadCitiesByState(cityInput, uf, { logPrefix = '[IBGE]' } = {}) {
    if (!cityInput) return;

    if (!uf) {
        setSelectPlaceholder(cityInput, 'Cidade*');
        cityInput.disabled = true;
        return;
    }

    try {
        cityInput.disabled = true;
        setSelectPlaceholder(cityInput, 'Carregando cidades...');

        const response = await fetch(`${IBGE_API_BASE}/estados/${encodeURIComponent(uf)}/municipios`);
        if (!response.ok) {
            throw new Error('Falha ao buscar cidades no IBGE');
        }

        const cities = await response.json();
        const sortedCities = Array.isArray(cities)
            ? cities.sort((a, b) => (a.nome || '').localeCompare(b.nome || ''))
            : [];

        setSelectPlaceholder(cityInput, 'Cidade*');
        appendSelectOptions(
            cityInput,
            sortedCities.map((city) => ({ value: city.nome, label: city.nome }))
        );

        cityInput.disabled = false;
    } catch (error) {
        setSelectPlaceholder(cityInput, 'Cidade*');
        cityInput.disabled = true;
        console.error(`${logPrefix} Erro ao carregar cidades:`, error);
    }
}
